import { CoursesTabResponse, GeneralTabResponse, LPCardReponse, ParticipantsTabResponse } from "components/pages/Reports/views/LearningPathActivityReport/types";

export const cardResponseMock: LPCardReponse = {
    id: 'lp-1',
    name: 'Listening para el trabajo',
    imageUrl: 'https://tse4.mm.bing.net/th?id=OIP.IGNf7GuQaCqz_RPq5wCkPgHaLH&pid=Api',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    // description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    createdAt: '2024-11-19T14:37:06.435Z',
    startDate: '2024-11-19T14:37:06.435Z',
    endDate: '2024-11-19T14:37:06.435Z'
}

export const generalTabResponseMock: GeneralTabResponse = {
    totalParticipants: 786,
    finishParticipants: 137,
    generalProgress: 74,
    averageDaysToFinish: 12,
    chart: {
        approvedUsers: 1637,
        disapprovedUsers: 1980,
        registeredUsers: 2786,
        inProgressUsers: 400,
    }
}

export const participantsTabResponseMock: ParticipantsTabResponse = {
    participantsCount: 13,
    participants: [
        {
            id: '1',
            name: 'Juan Pérez del Barrio de la Cuenca del Río de la Plata',
            email: 'juan.perez.del.barrio.de.la.cuenca.del.rio.de.la.plata@example.com',
            avatar: 'https://randomuser.me/api/portraits/men/1.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'IN_PROGRESS',
            registeredAt: new Date('2023-01-01').toISOString(),
            startedAt: new Date('2023-01-02').toISOString(),
            finishedAt: undefined,
            generalProgress: 50,
            courses: {
                'course-1': { courseProgress: 80, courseScore: 95, courseStatus: 'IN_PROGRESS', courseGroup: 'Grupo A' },
                'course-2': { courseProgress: 60, courseScore: 88, courseStatus: 'IN_PROGRESS', courseGroup: 'Grupo B' },
                'course-3': { courseProgress: 40, courseScore: 75, courseStatus: 'IN_PROGRESS', courseGroup: 'Grupo C' }
            }
        },
        {
            id: '2',
            name: 'Ana Gómez',
            email: 'ana.gomez@example.com',
            avatar: 'https://randomuser.me/api/portraits/women/1.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'APPROVED',
            registeredAt: new Date('2023-01-05').toISOString(),
            startedAt: new Date('2023-01-06').toISOString(),
            finishedAt: new Date('2023-04-01').toISOString(),
            generalProgress: 100,
            courses: {
                'course-1': { courseProgress: 100, courseScore: 98, courseStatus: 'APPROVED', courseGroup: 'Grupo A' },
                'course-2': { courseProgress: 100, courseScore: 99, courseStatus: 'APPROVED', courseGroup: 'Grupo A' },
                'course-3': { courseProgress: 100, courseScore: 97, courseStatus: 'APPROVED', courseGroup: 'Grupo B' }
            }
        },
        {
            id: '3',
            name: 'Carlos Ruiz',
            email: 'carlos.ruiz@example.com',
            avatar: 'https://randomuser.me/api/portraits/men/2.jpg',
            userStatus: 'INACTIVE',
            progressStatus: 'INACTIVE',
            registeredAt: new Date('2023-01-10').toISOString(),
            startedAt: undefined,
            finishedAt: undefined,
            generalProgress: 0,
            courses: {
                'course-1': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', },
                'course-2': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', },
                'course-3': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', }
            }
        },
        {
            id: '4',
            name: 'Lucía Martínez',
            email: 'lucia.martinez@example.com',
            avatar: 'https://randomuser.me/api/portraits/women/2.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'IN_PROGRESS',
            registeredAt: new Date('2023-02-15').toISOString(),
            startedAt: new Date('2023-02-16').toISOString(),
            finishedAt: undefined,
            generalProgress: 45,
            courses: {
                'course-1': { courseProgress: 45, courseScore: 70, courseStatus: 'IN_PROGRESS', },
                'course-2': { courseProgress: 50, courseScore: 75, courseStatus: 'IN_PROGRESS', },
                'course-3': { courseProgress: 40, courseScore: 65, courseStatus: 'IN_PROGRESS', }
            }
        },
        {
            id: '5',
            name: 'Roberto Hernández',
            email: 'roberto.hernandez@example.com',
            avatar: 'https://randomuser.me/api/portraits/men/3.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'IN_PROGRESS',
            registeredAt: new Date('2023-03-01').toISOString(),
            startedAt: new Date('2023-03-02').toISOString(),
            finishedAt: undefined,
            generalProgress: 60,
            courses: {
                'course-1': { courseProgress: 60, courseScore: 80, courseStatus: 'IN_PROGRESS', courseGroup: 'Grupo C' },
                'course-2': { courseProgress: 65, courseScore: 85, courseStatus: 'IN_PROGRESS', courseGroup: 'Grupo C' },
                'course-3': { courseProgress: 55, courseScore: 78, courseStatus: 'IN_PROGRESS', courseGroup: 'Grupo C' },
                'course-5': { courseProgress: 15, courseScore: 50, courseStatus: 'FAILED', courseGroup: 'Grupo C' },
            }
        },
        {
            id: '6',
            name: 'Elena Jiménez',
            email: 'elena.jimenez@example.com',
            avatar: 'https://randomuser.me/api/portraits/women/3.jpg',
            userStatus: 'INACTIVE',
            progressStatus: 'FAILED',
            registeredAt: new Date('2023-03-20').toISOString(),
            startedAt: new Date('2023-03-21').toISOString(),
            finishedAt: new Date('2023-06-10').toISOString(),
            generalProgress: 30,
            courses: {
                'course-1': { courseProgress: 30, courseScore: 45, courseStatus: 'FAILED', courseGroup: 'Grupo A' },
                'course-2': { courseProgress: 35, courseScore: 55, courseStatus: 'FAILED', courseGroup: 'Grupo B' },
                'course-3': { courseProgress: 25, courseScore: 40, courseStatus: 'FAILED', courseGroup: 'Grupo C' },
                'course-4': { courseProgress: 20, courseScore: 45, courseStatus: 'FAILED', courseGroup: 'Grupo C' },
                'course-5': { courseProgress: 15, courseScore: 50, courseStatus: 'FAILED', courseGroup: 'Grupo C' },
            }
        },
        {
            id: '7',
            name: 'Miguel Ángel Torres',
            email: 'miguel.torres@example.com',
            avatar: 'https://randomuser.me/api/portraits/men/4.jpg',
            userStatus: 'DELETED',
            progressStatus: 'INACTIVE',
            registeredAt: new Date('2023-04-01').toISOString(),
            startedAt: undefined,
            finishedAt: undefined,
            generalProgress: 0,
            courses: {
                'course-1': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', courseGroup: 'Grupo A' },
                'course-2': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', courseGroup: 'Grupo B' },
                'course-4': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', courseGroup: 'Grupo C' }
            }
        },
        {
            id: '8',
            name: 'Camila Rodríguez',
            email: 'camila.rodriguez@example.com',
            avatar: 'https://randomuser.me/api/portraits/women/4.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'APPROVED',
            registeredAt: new Date('2023-05-01').toISOString(),
            startedAt: new Date('2023-05-02').toISOString(),
            finishedAt: new Date('2023-08-01').toISOString(),
            generalProgress: 100,
            courses: {
                'course-5': { courseProgress: 100, courseScore: 95, courseStatus: 'APPROVED' },
                'course-2': { courseProgress: 100, courseScore: 98, courseStatus: 'APPROVED' },
                'course-3': { courseProgress: 100, courseScore: 92, courseStatus: 'APPROVED' }
            }
        },
        {
            id: '9',
            name: 'Fernando Morales',
            email: 'fernando.morales@example.com',
            avatar: 'https://randomuser.me/api/portraits/men/5.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'IN_PROGRESS',
            registeredAt: new Date('2023-05-15').toISOString(),
            startedAt: new Date('2023-05-16').toISOString(),
            finishedAt: undefined,
            generalProgress: 70,
            courses: {
                'course-1': { courseProgress: 70, courseScore: 90, courseStatus: 'IN_PROGRESS' },
                'course-2': { courseProgress: 75, courseScore: 92, courseStatus: 'IN_PROGRESS' },
                'course-4': { courseProgress: 65, courseScore: 87, courseStatus: 'IN_PROGRESS' },
                'course-5': { courseProgress: 65, courseScore: 87, courseStatus: 'IN_PROGRESS', courseGroup: 'Grupo A' },
                'course-3': { courseProgress: 65, courseScore: 87, courseStatus: 'IN_PROGRESS' }
            }
        },
        {
            id: '10',
            name: 'Isabel Núñez',
            email: 'isabel.nunez@example.com',
            avatar: 'https://randomuser.me/api/portraits/women/5.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'IN_PROGRESS',
            registeredAt: new Date('2023-06-01').toISOString(),
            startedAt: new Date('2023-06-02').toISOString(),
            finishedAt: undefined,
            generalProgress: 80,
            courses: {
                'course-1': { courseProgress: 85, courseScore: 94, courseStatus: 'IN_PROGRESS' },
                'course-2': { courseProgress: 80, courseScore: 90, courseStatus: 'IN_PROGRESS' },
                'course-3': { courseProgress: 75, courseScore: 88, courseStatus: 'IN_PROGRESS' }
            }
        },
        {
            id: '11',
            name: 'Diego López',
            email: 'diego.lopez@example.com',
            avatar: 'https://randomuser.me/api/portraits/men/6.jpg',
            userStatus: 'INACTIVE',
            progressStatus: 'INACTIVE',
            registeredAt: new Date('2023-07-01').toISOString(),
            startedAt: undefined,
            finishedAt: undefined,
            generalProgress: 0,
            courses: {
                'course-1': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', courseGroup: 'Grupo con un nombre muy largo que sobrepasa el espacio disponible' },
                'course-2': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', courseGroup: 'Grupo A' },
                'course-3': { courseProgress: 0, courseScore: 0, courseStatus: 'INACTIVE', courseGroup: 'Grupo A' }
            }
        },
        {
            id: '12',
            name: 'Laura García',
            email: 'laura.garcia@example.com',
            avatar: 'https://randomuser.me/api/portraits/women/6.jpg',
            userStatus: 'DELETED',
            progressStatus: 'FAILED',
            registeredAt: new Date('2023-08-01').toISOString(),
            startedAt: new Date('2023-08-02').toISOString(),
            finishedAt: new Date('2023-11-01').toISOString(),
            generalProgress: 30,
            courses: {
                'course-1': { courseProgress: 25, courseScore: 40, courseStatus: 'FAILED' },
                'course-2': { courseProgress: 30, courseScore: 45, courseStatus: 'FAILED' },
                'course-3': { courseProgress: 35, courseScore: 50, courseStatus: 'FAILED' }
            }
        },
        {
            id: '13',
            name: 'Sergio Martín',
            email: 'sergio.martin@example.com',
            avatar: 'https://randomuser.me/api/portraits/men/7.jpg',
            userStatus: 'ACTIVE',
            progressStatus: 'APPROVED',
            registeredAt: new Date('2023-09-01').toISOString(),
            startedAt: new Date('2023-09-02').toISOString(),
            finishedAt: new Date('2023-12-01').toISOString(),
            generalProgress: 100,
            courses: {
                'course-1': { courseProgress: 100, courseScore: 99, courseStatus: 'APPROVED' },
                'course-2': { courseProgress: 100, courseScore: 100, courseStatus: 'APPROVED' },
                'course-3': { courseProgress: 100, courseScore: 98, courseStatus: 'APPROVED' }
            }
        }
    ],
    courseColumns: [
        { id: 'course-1', name: 'Introducción a la Programación' },
        { id: 'course-2', name: 'Desarrollo Web Avanzado' },
        { id: 'course-3', name: 'Diseño de Bases de Datos' },
        { id: 'course-4', name: 'Teoría de Sistemas' },
        { id: 'course-5', name: 'Inteligencia Artificial' }
    ],
}

export const coursesTabResponseMock: CoursesTabResponse = {
    sectionsCount: 5,
    coursesCount: 18,
    totalDuration: 395685070, // Approx. 96 hours in milliseconds
    sections: [
        {
            id: "seccion-1",
            name: "Introducción al Aprendizaje",
            duration: 86400000, // 24 hours in milliseconds
            index: 1,
            courses: [
                {
                    id: "curso-1",
                    name: "Fundamentos del Aprendizaje",
                    moduleCount: 5,
                    startsAt: "2024-11-25T08:00:00Z",
                    endsAt: "2024-11-26T08:00:00Z",
                    isScheduled: true,
                },
                {
                    id: "curso-2",
                    name: "Cómo mejorar tus habilidades",
                    moduleCount: 3,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
            ],
        },
        {
            id: "seccion-2",
            name: "Habilidades Digitales",
            duration: 777777, // 36 hours in milliseconds
            index: 2,
            courses: [
                {
                    id: "curso-3",
                    name: "Introducción a las herramientas digitales",
                    moduleCount: 0,
                    startsAt: "2024-11-27T09:00:00Z",
                    endsAt: "2024-11-27T17:00:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-4",
                    name: "Uso avanzado de Excel",
                    moduleCount: 6,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-5",
                    name: "Gestión de proyectos en línea",
                    moduleCount: 2,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false
                },
            ],
        },
        {
            id: "seccion-3",
            name: "Crecimiento Personal",
            duration: 667799775, // 20 hours in milliseconds
            index: 3,
            courses: [
                {
                    id: "curso-6",
                    name: "Liderazgo en equipos remotos",
                    moduleCount: 8,
                    startsAt: "2024-11-28T10:00:00Z",
                    endsAt: "2024-11-28T15:00:00Z",
                    isScheduled: true
                },
                {
                    id: "curso-7",
                    name: "Comunicación efectiva",
                    moduleCount: 7,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: true
                },
                {
                    id: "curso-8",
                    name: "Manejo del estrés",
                    moduleCount: 5,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
            ],
        },
        {
            id: "seccion-4",
            name: "Programación Básica",
            duration: 77777, // 12 hours in milliseconds
            index: 4,
            courses: [
                {
                    id: "curso-9",
                    name: "Introducción a JavaScript",
                    moduleCount: 6,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-10",
                    name: "Variables y funciones",
                    moduleCount: 4,
                    startsAt: "2024-11-29T08:00:00Z",
                    endsAt: "2024-11-29T12:00:00Z",
                    isScheduled: false,
                },
            ],
        },
        {
            id: "seccion-5",
            name: "Avances Tecnológicos",
            duration: 14400000, // 4 hours in milliseconds
            index: 5,
            courses: [
                {
                    id: "curso-11",
                    name: "Inteligencia Artificial en la actualidad",
                    moduleCount: 2,
                    startsAt: "2024-11-30T10:00:00Z",
                    endsAt: "2024-11-30T11:30:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-12",
                    name: "Robótica aplicada",
                    moduleCount: 3,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
            ],
        },
        {
            id: "seccion-6",
            name: "Sección sin cursos",
            duration: 0,
            index: 7,
            courses: [],
        },
        {
            id: "seccion-7",
            name: "Formación Integral para Profesionales",
            duration: 216000000, // 60 hours in milliseconds
            index: 6,
            courses: [
                {
                    id: "curso-13",
                    name: "Gestión del tiempo en proyectos",
                    moduleCount: 3,
                    startsAt: "2024-12-01T09:00:00Z",
                    endsAt: "2024-12-01T12:00:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-14",
                    name: "Introducción al análisis financiero",
                    moduleCount: 4,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-15",
                    name: "Técnicas de negociación efectiva",
                    moduleCount: 2,
                    startsAt: "2024-12-02T14:00:00Z",
                    endsAt: "2024-12-02T16:30:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-16",
                    name: "Uso de herramientas colaborativas",
                    moduleCount: 5,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-17",
                    name: "Desarrollo de habilidades blandas",
                    moduleCount: 3,
                    startsAt: "2024-12-03T10:00:00Z",
                    endsAt: "2024-12-03T12:00:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-18",
                    name: "Introducción a la programación en Python",
                    moduleCount: 7,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-19",
                    name: "Estrategias de marketing digital",
                    moduleCount: 6,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-20",
                    name: "Presentaciones impactantes",
                    moduleCount: 2,
                    startsAt: "2024-12-04T08:30:00Z",
                    endsAt: "2024-12-04T10:30:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-21",
                    name: "Planificación estratégica empresarial",
                    moduleCount: 8,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-22",
                    name: "Introducción al diseño gráfico",
                    moduleCount: 5,
                    startsAt: "2024-12-05T13:00:00Z",
                    endsAt: "2024-12-05T15:00:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-23",
                    name: "Herramientas avanzadas de productividad",
                    moduleCount: 3,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-24",
                    name: "Conceptos básicos de economía",
                    moduleCount: 4,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-25",
                    name: "Creación de contenido multimedia",
                    moduleCount: 7,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
                {
                    id: "curso-26",
                    name: "Automatización de tareas repetitivas",
                    moduleCount: 6,
                    startsAt: "2024-12-06T09:00:00Z",
                    endsAt: "2024-12-06T11:00:00Z",
                    isScheduled: false,
                },
                {
                    id: "curso-27",
                    name: "Bases de datos relacionales",
                    moduleCount: 5,
                    startsAt: undefined,
                    endsAt: undefined,
                    isScheduled: false,
                },
            ],
        },
    ],
};